import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import { Button } from '../../../../../common/button';
import ProductAvailabilityForm from './product_availability_form';
import ProductAvailabilityPopsForm from './product_availability_pops_form';
import { Divider, IconButton, Tooltip } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

const ProductAvailabilityFormDialog = ({ displayIcon, refreshCalendar, initialDate }) => {
    const [view, setView] = useState(0);
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});

    const onClose = () => {
        setData({});
        setView(0);
        setOpen(false);
    };

    const renderView = () => {
        if (view === 1) {
            return (
                <ProductAvailabilityPopsForm
                    data={ data }
                    onClose={ onClose }
                    setView={ setView }
                    refreshCalendar={ refreshCalendar }/>
            );
        } else {
            return (
                <ProductAvailabilityForm
                    data={ data }
                    onClose={ onClose }
                    setData={ setData }
                    setView={ setView }
                    initialDate={ initialDate }
                    refreshCalendar={ refreshCalendar }/>
            );
        }
    };

    return (
        <>
            {
                displayIcon ? (
                    <Tooltip title="Dodaj produkt do kalendarza">
                        <IconButton size="small" onClick={ () => setOpen(true) }>
                            <AddIcon fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Button onClick={ () => setOpen(true) }>
                        Dodaj produkt do kalendarza
                    </Button>
                )
            }
            <Dialog disableRestoreFocus PaperProps={ { sx: { maxHeight: 800 } } } open={ open } onClose={ onClose }
                    fullWidth maxWidth="lg">
                <DialogTitle sx={ { fontWeight: 600, pb: 1 } }>Dodaj produkt do kalendarza</DialogTitle>
                <Divider/>

                <DialogContent sx={ { paddingTop: '20px !important', pb: 3 } }>
                    { renderView() }
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ProductAvailabilityFormDialog;